module.exports = __webpack_public_path__ + "static/img/pool_footage.e8875c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/bg/pool_footage.jpg
// module id = S1PH
// module chunks = 4